import React, { useRef, useState } from "react";
import Title from "../../Title";
import Icon from "../../Icon";

import "./index.css";

interface FullScreenVideoTemplateProps {
  data: DataFullScreenVideoTemplate;
}

const FullScreenVideoTemplate = ({ data }: FullScreenVideoTemplateProps) => {
  const { videoSrc, title, onClose } = data;
  const templateType = "full-screen-video-template";
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleRewind = () => {
    if (videoRef.current) {
      videoRef.current.currentTime -= 10;
    }
  };

  const handleForward = () => {
    if (videoRef.current) {
      videoRef.current.currentTime += 10;
    }
  };

  const handleTimeUpdate = () => {
    if (videoRef.current) {
      setCurrentTime(videoRef.current.currentTime);
    }
  };

  const handleSeek = (event: React.MouseEvent<HTMLDivElement>) => {
    if (videoRef.current) {
      const rect = event.currentTarget.getBoundingClientRect();
      const offsetX = event.clientX - rect.left;
      const progress = offsetX / rect.width;
      videoRef.current.currentTime = videoRef.current.duration * progress;
    }
  };

  const handleClose = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
    onClose();
  };

  const ButtonsMenu = () => (
    <div className="full-screen-video-template_control-buttons">
      <div onClick={handleForward}>
        <Icon type="forwardButton" color="white" />
      </div>
      <div onClick={handleRewind}>
        <Icon type="rewindButton" color="white" />
      </div>
      <div onClick={togglePlay}>{isPlaying ? <Icon type="pauseButton" color="white" /> : <Icon type="playButton" color="white" />}</div>
    </div>
  );

  return (
    <div className="full-screen-video-template">
      <div className="full-screen-video-template_header">
        <Title type={templateType} text={title} />
        <div onClick={handleClose}>
          <Icon type="closeCircle" color="#7C7C7C" />
        </div>
      </div>
      <div className="full-screen-video-template_video-panel">
        <div className="full-screen-video-template_control-buttons-left">
          <ButtonsMenu />
        </div>
        <div className="full-screen-video-template_video-container">
          <video
            ref={videoRef}
            src={require(`../../../Assets/videos/${videoSrc}`)}
            onTimeUpdate={handleTimeUpdate}
            onPause={() => setIsPlaying(false)}
            onPlay={() => setIsPlaying(true)}
            className="full-screen-video-template_video"
          ></video>
        </div>
        <div className="full-screen-video-template_control-buttons-right">
          <ButtonsMenu />
        </div>
      </div>
      {videoRef.current?.duration && (
        <div className="full-screen-video-template_progress-bar" onClick={handleSeek}>
          <div
            className="full-screen-video-template_progress"
            style={{
              width: `${(currentTime / videoRef.current?.duration) * 100}%`,
            }}
          ></div>
        </div>
      )}
    </div>
  );
};

export default FullScreenVideoTemplate;
